import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { DashboardFolderTreeNodeT } from 'business/definitions';
import DashboardFolderEditMenu from 'modules/decision/pages/AllDashboards/components/DashboardFolderEditMenu/DashboardFolderEditMenu';
import * as React from 'react';
import GenericCard from 'ui/Card/GenericCard';

import { getTotalDashboardsCount } from './helpers/getTotalDashboardsCount';

type Props = {
    folder: DashboardFolderTreeNodeT;
    shouldShowParentFolder: boolean;
    onClick?: () => void;
};

const DashboardFolderCard = ({
    folder,
    shouldShowParentFolder,
    onClick = () => {},
}: Props): React.ReactElement => {
    return (
        <GenericCard
            isFolder
            title={folder.name}
            folder={
                shouldShowParentFolder && folder.parentFolder
                    ? { name: folder.parentFolder.name }
                    : undefined
            }
            icon={<FolderSharedOutlinedIcon />}
            action={
                <DashboardFolderEditMenu dashboardFolder={folder} show small />
            }
            onClick={onClick}
            className="pendo-folder-card"
            chipIcon={<DashboardIcon />}
            chipLabel={`${getTotalDashboardsCount(folder)}`}
            size="md"
        />
    );
};

export default DashboardFolderCard;
